import Vue from 'vue'

export async function fetchTaskTime({ commit }, taskId) {
  await Vue.axios({
    url: '/chronometer/' + taskId + '/get_time_spend/'
  }).then((response) => {
    commit('saveNewTimer', response.data)
  }).catch((error) => {
    commit('error', error.mesage)
  })
}

export async function send_minute_spent({ commit }, taskId) {
  let toReturn = ""
  await Vue.axios({
    method: 'POST',
    url: '/chronometer/add_partial_time/',
    data: {
      timeSpentSeconds: 60,
      task: taskId,
      completeTask: false
    },
    json: true
  }).then((response) => {
    commit('saveNewTimer', response.data.timer)
    //console.log(response)
    //console.log(response.data)
    toReturn = response.data
  }).catch((error) => {
    commit('error', error.mesage)
  })
  return toReturn
}

export async function send_total_time({ commit }, payload) {
  let toReturn = ""
  await Vue.axios({
    method: 'POST',
    url: '/chronometer/',
    data: {
      timeSpentSeconds: payload.totalTime,
      task: payload.taskId,
      completeTask: payload.isComplete
    }
  }).then((response) => {
    commit('saveNewTimer', response.data.timer)
    //console.log(response)
    //console.log(response.data)
    toReturn = response.data
  }).catch((error) => {
    commit('error', error.mesage)
  })
  return toReturn
}